import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { loadStripe } from '@stripe/stripe-js';

//get from env?
const stripePromise = loadStripe('pk_live_51Ron9KRw3Yh5EmBTaysg9H87HHpWKuHPjqBuSLwVmxHmeY8MAygwA0aIzqtlTYeQ7FxcJuZ3wRjh0zQdFBGOBKr5006fMXd0fA');

const Checkout = (props) => {
  const [formData, setFormData] = useState({ name: '', email: '', amount: parseInt(props.paymentDue), address:'', address2:'', city:'', state:'', zipCode:'', });
  const [paymentStatus, setPaymentStatus] = useState('');
  const [paymentPossible, setPaymentPossible] = useState(true);
  const [loading, setLoading] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'amount' ? parseInt(value) : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const stripe = await stripePromise;

    try {
      const createStripeCheckout = httpsCallable(functions, 'createStripeCheckout');
      
      setLoading(true);
      /*
      const name = e.target[0].value;
      const email = e.target[1].value;
      const address = e.target[2].value;
      const address2 = e.target[3].value;
      const state = e.target[4].value;
      const city = e.target[5].value;
      const zipCode = e.target[6].value;
      */

      const checkoutItems = props.checkoutItems

      const amountDue = parseInt(props.paymentDue) * 100;

      const checkoutObject = {amount:amountDue, checkoutItems: checkoutItems};
      //console.log(checkoutObject)

      createStripeCheckout(checkoutObject)
        .then(response => {
          const sessionId = response.data.id;
          stripe.redirectToCheckout({sessionId: sessionId})
        })

      //setResponse(result.data.message);
    } catch (error) {
      console.error("Error calling function:", error);
      //setResponse("Error calling function.");
    } finally {
      setLoading(false);
    }
  }
  
  return (
    <>
        <form onSubmit={(e)=>{handleSubmit(e)}} className="formCheckout">
          {!paymentPossible && 
            <div className="checkoutDisabledScreen">
              <div className="blurScreen" />
              <p>Zeroz Checkout will be live by August 11th! The process is complete, juuuuuust want to double check security and Data Architecture before going fully live.</p>
            </div>
          }
          {/* form, if we want to collect information
          <p>Contact Information</p>
          <div className="row" >
            <input name="name" value={formData.name} onChange={handleChange} placeholder="Name" required />
            <input name="email" value={formData.email} onChange={handleChange} placeholder="Email" required />
          </div>
          <p>Shipping Address</p>
          <div className="row" >
            <input name="address" value={formData.address} onChange={handleChange} placeholder="Address" required />
            <input name="address2" value={formData.address2} onChange={handleChange} placeholder="Apt, suite, or unit" />
          </div>
          <div className="row" >
            <input name="city" value={formData.city} onChange={handleChange} placeholder="City" required />
            <select id="state" name="state" value={formData.state} onChange={handleChange} placeholder="State" required >
              <option value="">Select Your State</option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
            </select>
            <input name="zipCode" value={formData.zipCode} onChange={handleChange} placeholder="Zipcode" required />
          </div>
          */}
          <div className="row">
            <button style={{width:'300px', display:'flex', justifyContent:'center', alignItems:'center'}} type="submit" disabled={!paymentPossible/*!stripe*/}>{loading ? 'Go to Shipping & Payment' : <div className='loadingIcon'/> }</button>
            <p style={{fontSize: '1rem', marginLeft: '15px'}}>We use stripe for secure checkout</p>
          </div>
          {paymentStatus && <p>{paymentStatus}</p>}
        </form>
    </>
  );
};

export default Checkout;